import {ReportDataService} from '../../report-data.service';

export class FlexFileError {

  description = '';
  type = '';
  count = 0;
  isFatal = false;
  additionalData = [];
  protected reportService: ReportDataService;

  constructor(reportService: ReportDataService, description: string, type: string, count: number, isFatal: boolean = false, additionalData = null) {
    this.reportService = reportService;
    this.description = description;
    this.type = type;
    this.count = count;
    this.isFatal = isFatal;
    this.additionalData = additionalData;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/errors/FlexFileError.ts